import { jsx as t, jsxs as a } from "react/jsx-runtime";
import { P as d, T as p } from "../../../toast-DswZwq5W.js";
import { ToastContext as h } from "./toast.context.js";
import { useToastProvider as m } from "./toast.hook.js";
function x({ children: e, duration: r = 5e3 }) {
  const { activeToast: o, open: s, handleOpenChange: i, showToast: n } = m();
  return /* @__PURE__ */ t(h.Provider, { value: { showToast: n }, children: /* @__PURE__ */ a(d, { swipeDirection: "down", swipeThreshold: 15, duration: r, children: [
    e,
    o && /* @__PURE__ */ t(
      p,
      {
        status: o.status,
        text: o.text,
        open: s,
        onOpenChange: i
      },
      o.id
    )
  ] }) });
}
export {
  x as ToastProvider
};
